import React from 'react';
var ArrowGroup = function (props) {
    var leftBtnOnClick = props.leftBtnOnClick, rightBtnOnClick = props.rightBtnOnClick, prefixCls = props.prefixCls, style = props.style;
    return (React.createElement("ul", { className: prefixCls + "__arrow-group", style: style },
        React.createElement("li", { onClick: leftBtnOnClick, className: prefixCls + "__arrow-left" }, "left"),
        React.createElement("li", { onClick: rightBtnOnClick, className: prefixCls + "__arrow-right" }, "right")));
};
export default ArrowGroup;
//# sourceMappingURL=arrow-group.js.map